import React from "react";
import { ListInput } from "./list-input";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "当該方法で申請を行うことができる方を列挙します。",
  "例: 本人",
  "例: 代理人",
];

type Props = InputProps &
  PathProps & {
    value: string[];
    validationErrors: string[];
  };

export const ProcedureApplicantsListInput: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
  basePath,
  shouldDisplayError = false,
  validationErrors,
}) => {
  return (
    <ListInput
      label="申請者"
      required
      component={SimpleTextInput}
      componentProps={value.map((applicant, i) => ({
        value: applicant,
        onChange,
        shouldDisplayError: shouldDisplayError,
        errorMsg: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, ""]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
